import pushEcommerceTrackingEvent from '../helpers/pushEcommerceTrackingEvent';
import getItemsArray from '../helpers/getItemsArray';
import { getItemListName } from '../helpers/getItemListName';
import CurrencyFormatter from '../../../../js/helper/currency-formatter';

export function trackViewItemList(id, templateName, pageTitle, products, transformerFn) {
    const itemListName = getItemListName(templateName, pageTitle);

    pushEcommerceTrackingEvent('view_item_list', {
        currency: CurrencyFormatter.currency(),
        item_list_id: id,
        item_list_name: itemListName,
        items: getItemsArray(products, transformerFn),
    });
}
